var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dish-form" },
    [
      _c("el-card", { staticClass: "form-card", attrs: { shadow: "hover" } }, [
        _c(
          "div",
          {
            staticClass: "card-header",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("i", { staticClass: "el-icon-food" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.type === "add" ? "新增商品" : "编辑商品")),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-content" },
          [
            _c(
              "el-form",
              {
                ref: "formRef",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  "label-width": "120px",
                },
              },
              [
                _c("div", { staticClass: "form-container" }, [
                  _c(
                    "div",
                    { staticClass: "left-section" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "所属品牌", prop: "brandId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: "",
                                placeholder: "请选择品牌",
                              },
                              model: {
                                value: _vm.form.brandId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "brandId", $$v)
                                },
                                expression: "form.brandId",
                              },
                            },
                            _vm._l(_vm.brandList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.brandName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "菜品分类", prop: "categories" } },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: "",
                              options: _vm.categories,
                              props: { value: "id", leaf: "leaf" },
                            },
                            model: {
                              value: _vm.form.categories,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "categories", $$v)
                              },
                              expression: "form.categories",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "pos菜品编码" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "", placeholder: "-" },
                            model: {
                              value: _vm.form.outerGoodsId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "outerGoodsId", $$v)
                              },
                              expression: "form.outerGoodsId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "菜品类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "", placeholder: "-" },
                              model: {
                                value: _vm.form.goodsType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "goodsType", $$v)
                                },
                                expression: "form.goodsType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { value: 1, label: "单品" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { value: 2, label: "套餐" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "菜品名称（中）", prop: "goodsName" },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.goodsName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "goodsName", $$v)
                              },
                              expression: "form.goodsName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "菜品名称（英）",
                            prop: "goodsNameEn",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.goodsNameEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "goodsNameEn", $$v)
                              },
                              expression: "form.goodsNameEn",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "菜品简介", prop: "goodsBrief" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 4, maxRow: 6 },
                            },
                            model: {
                              value: _vm.form.goodsBrief,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "goodsBrief", $$v)
                              },
                              expression: "form.goodsBrief",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "餐盒费", prop: "boxPrice" } },
                        [
                          _c("el-input-number", {
                            attrs: { number: "", min: 0 },
                            model: {
                              value: _vm.form.boxPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "boxPrice", $$v)
                              },
                              expression: "form.boxPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "right-section" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "菜品标签", prop: "goodsLabel" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.goodsLabel,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "goodsLabel", $$v)
                              },
                              expression: "form.goodsLabel",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "菜品属性标签",
                            prop: "goodsAttrLabel",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.goodsAttrLabel,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "goodsAttrLabel", $$v)
                              },
                              expression: "form.goodsAttrLabel",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "菜品角标", prop: "goodsSubscript" },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.goodsSubscript,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "goodsSubscript", $$v)
                              },
                              expression: "form.goodsSubscript",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "列表图" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                action: "#",
                                "on-remove": function (file, fileList) {
                                  return _vm.handleRemoveFile(
                                    file,
                                    fileList,
                                    "thumbnail"
                                  )
                                },
                                "file-list": _vm.thumbnailFileList,
                                "http-request": function (options) {
                                  return _vm.handlePictureUpload(
                                    options,
                                    "thumbnail"
                                  )
                                },
                                "on-preview": _vm.handlePreview,
                                "list-type": "picture-card",
                                "auto-upload": true,
                                accept: "image/*",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-tip" }, [
                            _vm._v("图片格式：jpg/png，大小≤2MB，尺寸305*402"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "封面图" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                action: "#",
                                "on-remove": function (file, fileList) {
                                  return _vm.handleRemoveFile(
                                    file,
                                    fileList,
                                    "img"
                                  )
                                },
                                "file-list": _vm.coverFileList,
                                "http-request": function (options) {
                                  return _vm.handlePictureUpload(options, "img")
                                },
                                "on-preview": _vm.handlePreview,
                                "list-type": "picture-card",
                                "auto-upload": true,
                                accept: "image/*,video/mp4,video/3gpp,.m3u8",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "file",
                                  fn: function (ref) {
                                    var file = ref.file
                                    return _c("div", {}, [
                                      !file.isVideo
                                        ? _c("img", {
                                            staticClass:
                                              "el-upload-list__item-thumbnail",
                                            attrs: { src: file.url, alt: "" },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "video-thumbnail-wrap",
                                            },
                                            [
                                              _c("video", {
                                                staticClass:
                                                  "el-upload-list__item-thumbnail",
                                                attrs: {
                                                  src: file.url,
                                                  muted: "",
                                                  preload: "metadata",
                                                },
                                                domProps: { muted: true },
                                              }),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-video-play video-play-icon",
                                              }),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-actions",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-preview",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handlePreview(file)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-zoom-in",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-delete",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleRemoveFile(
                                                    file,
                                                    _vm.coverFileList,
                                                    "img"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  },
                                },
                              ]),
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-tip" }, [
                            _vm._v(
                              "支持 jpg、png、gif、mp4、3gp、m3u8 格式，图片不超过2MB，视频不超过50MB，建议尺寸305*402"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品轮播图" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                action: "#",
                                "on-remove": function (file, fileList) {
                                  return _vm.handleRemoveBannerFile(
                                    file,
                                    fileList
                                  )
                                },
                                "file-list": _vm.bannerFileList,
                                "http-request": _vm.handleBannerUpload,
                                "on-preview": _vm.handlePreview,
                                "list-type": "picture-card",
                                "auto-upload": true,
                                accept: "image/*,video/mp4,video/3gpp,.m3u8",
                                multiple: "",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "file",
                                  fn: function (ref) {
                                    var file = ref.file
                                    return _c("div", {}, [
                                      !file.isVideo
                                        ? _c("img", {
                                            staticClass:
                                              "el-upload-list__item-thumbnail",
                                            attrs: { src: file.url, alt: "" },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "video-thumbnail-wrap",
                                            },
                                            [
                                              _c("video", {
                                                staticClass:
                                                  "el-upload-list__item-thumbnail",
                                                attrs: {
                                                  src: file.url,
                                                  muted: "",
                                                  preload: "metadata",
                                                },
                                                domProps: { muted: true },
                                              }),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-video-play video-play-icon",
                                              }),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-actions",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-preview",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handlePreview(file)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-zoom-in",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-delete",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleRemoveBannerFile(
                                                    file,
                                                    _vm.bannerFileList
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  },
                                },
                              ]),
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-tip" }, [
                            _vm._v(
                              "支持 jpg、png、gif、mp4、3gp、m3u8 格式，图片不超过2MB，视频不超过50MB，可上传多张"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-footer" },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$emit("cancel")
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
                  [_vm._v("确认")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.previewMediaDialog.isVideo ? "视频预览" : "图片预览",
            visible: _vm.previewMediaDialog.visible,
            width: "600px",
            "append-to-body": "",
            "destroy-on-close": true,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.previewMediaDialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
                "min-height": "200px",
              },
            },
            [
              _vm.previewMediaDialog.isVideo
                ? _c("video", {
                    staticStyle: {
                      "max-width": "100%",
                      "max-height": "65vh",
                      "border-radius": "4px",
                    },
                    attrs: {
                      src: _vm.previewMediaDialog.url,
                      controls: "",
                      autoplay: "",
                    },
                  })
                : _c("img", {
                    staticStyle: {
                      "max-width": "100%",
                      "max-height": "65vh",
                      "object-fit": "contain",
                      "border-radius": "4px",
                    },
                    attrs: { src: _vm.previewMediaDialog.url, alt: "预览图" },
                  }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }